import {
  LiveEventAudienceEnum,
  LiveEventTypeEnum,
} from "@/__generated__/types";
import { i18n } from "@/i18n";

export const DATE_FORMAT = "PPPp";
export const PLACEHOLDER_FALLBACK = "--";

export const getEventTypeLabel = (eventType: LiveEventTypeEnum): string => {
  switch (eventType) {
    case LiveEventTypeEnum.LiveEvent:
      return i18n.t("gamesAndLiveEvents.table.eventTypes.liveEvent");
    case LiveEventTypeEnum.BotEvent:
      return i18n.t("gamesAndLiveEvents.table.eventTypes.automatedGame");
    default:
      return String(eventType);
  }
};

export const getAudienceLabel = (audience: LiveEventAudienceEnum): string => {
  switch (audience) {
    case LiveEventAudienceEnum.Everyone:
      return i18n.t("gamesAndLiveEvents.table.audience.everyone");
    case LiveEventAudienceEnum.Applicants:
      return i18n.t("gamesAndLiveEvents.table.audience.applicants");
    case LiveEventAudienceEnum.Admits:
      return i18n.t("gamesAndLiveEvents.table.audience.admits");
    case LiveEventAudienceEnum.Commits:
      return i18n.t("gamesAndLiveEvents.table.audience.commits");
    case LiveEventAudienceEnum.Other:
      return i18n.t("gamesAndLiveEvents.table.audience.other");
    default:
      return String(audience);
  }
};
